<script type="text/jsx">
import {
  StyledRadioButton,
  StyledRadioButtonInput,
  StyledRadioButtonLabel
} from './StyledRadioButton'
export default {
  name: 'RadioButton',
  props: ['value', 'name', 'label', 'checked'],
  render () {
    return (
      <StyledRadioButton>
        <StyledRadioButtonInput
          type="radio"
          value={this.value}
          name={this.name}
        />
        <StyledRadioButtonLabel
          checked={this.checked}
          onClick={() => { this.$emit('changeRadio', this.value) }}>{ this.label }
        </StyledRadioButtonLabel>
      </StyledRadioButton>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RadioButton/RadioButton.vue